import styled from "styled-components";

export const Root = styled.div`
margin: 25px 15px;
`;
export const Container = styled.div`
padding: 0 15px;
`;
export const TextWrapper = styled.div``;
export const Text = styled.text`
/* font-family:swera-demo; */
 font-style: normal;
font-weight: 700;
font-size: 36px;
line-height: 32px;
display: flex;
align-items: center;
margin-top: 50px;
`;

export const NftsWrapperContainer = styled.div`
display:grid;
grid-template-columns:1fr 1fr 1fr 1fr;
margin:20px 0 0 0;
width: 100%;

`;
export const NftsWrapper = styled.div`
display: flex;
justify-content:space-evenly;
align-items:center;
background: #000000;
border-radius: 20px;
padding: 15px 0px;
width: 85%;
border: 1px solid transparent;
background: linear-gradient(black 0 0) padding-box, 
linear-gradient(to bottom, #A73EE7, #FF0000) border-box;


`;
export const ImageWrapper = styled.div`
background-color:#191919;;
`;
export const Image = styled.img`
padding:30px;
border-radius:5px;
`;
export const NftTextWrapper = styled.div`
display: flex;
    flex-direction: column;
`;
export const NftText = styled.text`
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    padding: 0;
    
`;

export const NftQuantity = styled.div`
font-style: normal;
font-weight: 600;
font-size: 24px;
line-height: 29px;
padding-top:10px;
`;


/////////////////   Top Auction ////////////////

export const AuctionTextWrapper = styled.div`
/* padding-bottom: 20px; */
/* margin: 20px 0; */
/* padding: -10px 0 0 0; */
padding: 0px 0px 38px 0px;

`;
export const AuctionText = styled.div`
/* font-family: 'Swera Demo'; */
font-style: normal;
font-weight: 700;
font-size: 36px;
line-height: 32px;
display: flex;
align-items: center;
`;
export const AuctionWrapperContainer = styled.div`
background: linear-gradient(232deg, rgba(0, 66, 255, 0.5) -15.84%, rgba(235, 0, 27, 0.5) 98.75%);
/* padding: 10px 15px;border-radius: 8px; */
padding: 30px 20px;
border-radius:8px;
opacity:0.9;
`;

export const MagicAuctionWrapper = styled.div`
padding: 0px 0px 20px 0;
`;
export const MagicAuctionText = styled.text`
font-family: 'Lato';
font-style: normal;
font-weight: 700;
font-size: 32px;
line-height: 38px;
display: flex;
align-items: center;
`;
export const AuctionProfileWrapperContainer = styled.div``;
export const AuctionProfileWrapper = styled.div`
display: flex;
align-items:center;

`;
export const AuctionProfile = styled.img``;
export const AuctionProfileTextWrapper = styled.div`
padding: 0 15px;
`;
export const AuctionProfileText = styled.text`
font-style: normal;
font-weight: 600;
font-size: 14px;
line-height: 17px;
padding: 2px 0;
display: flex;
align-items: center;
`;
export const AuctionProfileEmail = styled.text`
font-family: 'Lato';
font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 14px;
display: flex;
align-items: center;
color: rgba(255, 255, 255, 0.7);
padding: 2px 0;
`;

export const AuctionProfileImage = styled.img`

`;
export const AuctionAbsoluteImage = styled.img`
position: absolute;
top: -9%;
left: 65%;
`;

export const NftpriceStartWrapper = styled.div`
display: flex;
padding: 30px 0
`;

export const AuctionpriceTextWrapper = styled.div`

`;
export const AuctionNftText = styled.text`
font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 15px;
display: flex;
align-items: center;
`;
export const AuctionNftPriceIconWrapper = styled.div`
display: flex;
padding:20px 0;

`;
export const AuctionNftIcon = styled.img``;
export const AuctionNftPrice = styled.text`
font-style: normal;
font-weight: 600;
font-size: 20px;
line-height: 24px;
display: flex;
align-items: center;
`;

export const AuctionpriceStartsWrapper = styled(AuctionpriceTextWrapper)`
padding: 0 40px;
`;


export const AuctionButtonWrapper = styled.div`
display:flex;
margin-top: -10px;
`;
export const ViewRewardsButtonWrapper = styled.div`

`;
export const ViewRewardsButton = styled.button`
padding: 18px 22px;
background: rgba(255, 255, 255, 0.75);
    border: none;
    outline: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor:pointer;
`;
export const ViewCollection = styled(ViewRewardsButton)`
border: 1px solid white;
background: none;
color: white;
margin:0 20px;
`;




////////////////////////////     Recent Collection       //////////////////

export const CollectionWithDropdornCOntainer = styled.div`
display: flex;
justify-content:space-between;
align-items:Center;
text-align:center;
padding-bottom: 20px;
`;
export const CollectionDropdownWrapper = styled.div`
padding: 0 30px;
`;

export const CollectionGridNftContainer = styled.div`
display: grid;
grid-template-columns:1fr 1fr 1fr 1fr;
grid-gap:0px;
`;
export const CollectionGridWrapper = styled.div`
background: linear-gradient(160.61deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 101.7%);
border-width: 2.5px 0px;
border-style: solid;
border-color: rgba(255, 255, 255, 0.4);
backdrop-filter: blur(17.915px);
border-radius: 30px;
width:90%;
padding:20px 0;
`;
export const CollectionImageWrapper = styled.div`
display:flex;
justify-content:center;
align-items:center;

`;
export const CollectionImage = styled.img``;
export const CollectionNftTextWrapper = styled.div`
padding:20px 30px 0px 30px;
`;
export const CollectionNftText = styled.text`
font-style: normal;
font-weight: 500;
font-size: 20px;
line-height: 24px;
text-transform: capitalize;
color: #FFFFFF;
`;
export const CollectionNftPrice = styled.div`
font-style: normal;
font-weight: 500;
font-size: 17px;
line-height: 20px;
text-transform: capitalize;
color: #FFFFFF;
padding: 10px 0 0 0;
`;